import { motion } from "motion/react";

interface CertificationBadge {
  id: string;
  alt: string;
  src: string;
  imageClassName?: string;
}

const badges: CertificationBadge[] = [
  {
    id: "iso",
    alt: "ISO 9001:2015 Certified Company",
    src: "/certifications/ISO_badge.png",
  },
  {
    id: "startup-india",
    alt: "DPIIT #StartupIndia Recognized",
    src: "/certifications/startup_india_badge.jpg",
    imageClassName: "scale-125 md:scale-135",
  },
  {
    id: "msme",
    alt: "Ministry of MSME Government of India",
    src: "/certifications/MSME_badge.jpg",
  },
];

export default function CertificationsMarquee() {
  return (
    <div className="w-full relative z-10 py-8 sm:py-12 md:py-16 overflow-hidden bg-black/[0.02] dark:bg-white/[0.01]">
      <div className="w-full max-w-[1280px] mx-auto px-4 flex flex-col lg:flex-row items-center gap-6 sm:gap-8 lg:gap-10">
        {/* ── Left Side (30%): Big Heading ── */}
        <div className="w-full lg:w-[30%] shrink-0 text-left">
          {/* Enhanced Live Status Pill */}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 dark:bg-indigo-500/15 border border-indigo-500/20 mb-3 md:mb-4">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500" />
            </span>
            <span className="font-Montserrat text-[10px] sm:text-xs font-semibold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
              Official Accreditations
            </span>
          </div>

          <h2 className="font-Montserrat text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-black dark:text-white leading-[1.15]">
            Recognised & <br className="hidden sm:inline" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-black dark:from-white via-indigo-600 dark:via-indigo-300 to-indigo-500">
              Certified by:
            </span>
          </h2>
        </div>

        {/* ── Right Side (70%): Running Marquee with Ultra-Smooth Alpha Mask ── */}
        <div
          className="w-full lg:w-[70%] relative overflow-hidden flex items-center"
          style={{
            maskImage:
              "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%)",
          }}
        >
          <motion.div
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              duration: 36,
              ease: "linear",
              repeat: Infinity,
            }}
            className="flex shrink-0 items-center py-2"
          >
            {/* Block 1 */}
            <div className="flex shrink-0 items-center gap-4 sm:gap-6 md:gap-8 pr-4 sm:pr-6 md:pr-8">
              {[...badges, ...badges].map((badge, index) => (
                <div
                  key={`b1-${badge.id}-${index}`}
                  className="w-44 h-28 sm:w-52 sm:h-32 md:w-64 md:h-40 rounded-2xl md:rounded-3xl bg-white p-2.5 md:p-3.5 flex items-center justify-center shadow-sm hover:shadow-xl hover:shadow-indigo-500/10 border border-black/10 hover:border-indigo-500/40 hover:scale-105 transition-all duration-300 shrink-0 select-none cursor-default overflow-hidden"
                >
                  <img
                    src={badge.src}
                    alt={badge.alt}
                    loading="lazy"
                    className={`h-full w-full max-h-20 sm:max-h-24 md:max-h-32 object-contain filter contrast-[1.03] transition-transform duration-300 ${
                      badge.imageClassName ?? ""
                    }`}
                  />
                </div>
              ))}
            </div>

            {/* Block 2 (Exact duplicate for 100% seamless loop) */}
            <div className="flex shrink-0 items-center gap-4 sm:gap-6 md:gap-8 pr-4 sm:pr-6 md:pr-8">
              {[...badges, ...badges].map((badge, index) => (
                <div
                  key={`b2-${badge.id}-${index}`}
                  className="w-44 h-28 sm:w-52 sm:h-32 md:w-64 md:h-40 rounded-2xl md:rounded-3xl bg-white p-2.5 md:p-3.5 flex items-center justify-center shadow-sm hover:shadow-xl hover:shadow-indigo-500/10 border border-black/10 hover:border-indigo-500/40 hover:scale-105 transition-all duration-300 shrink-0 select-none cursor-default overflow-hidden"
                >
                  <img
                    src={badge.src}
                    alt={badge.alt}
                    loading="lazy"
                    className={`h-full w-full max-h-20 sm:max-h-24 md:max-h-32 object-contain filter contrast-[1.03] transition-transform duration-300 ${
                      badge.imageClassName ?? ""
                    }`}
                  />
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
